var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": ("/chapter/" + (this.chapter.id))
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-ios-arrow-back"
  })]), _vm._v("\n            Return to Overview\n          ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-size-2"
  }, [_vm._v(_vm._s(_vm.chapter.artist) + ": " + _vm._s(_vm.chapter.title))]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-size-4"
  }, [_vm._v(_vm._s(_vm.chapter.author))])])])]), _vm._v(" "), _c('article', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content is-medium",
    domProps: {
      "innerHTML": _vm._s(_vm.essay)
    }
  })])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00a38fce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Essay.vue
// module id = LS5C
// module chunks = 0